module.exports = __webpack_public_path__ + "img/HeBo Trailers-19.7a47091e.jpg";